import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PortalAllDone } from "@/features/portal/components/portal-all-done"
import { PortalTaskList } from "@/features/portal/components/portal-task-list"
import { portalQueries } from "@/queries/portal"

export const Route = createFileRoute("/$organisation/portal/_portal/")({
  loader: async ({ context }) => {
    if (context.linked) {
      await context.queryClient.ensureQueryData(portalQueries.tasks())
    }
  },
  component: PortalPage,
})

function PortalPage() {
  const { linked, brand } = Route.useRouteContext()

  return linked ? (
    <PortalTasks principal={brand.name} name={linked.firstName} />
  ) : null
}

function PortalTasks({ principal, name }: { principal: string; name: string }) {
  const { data: tasks } = useSuspenseQuery(portalQueries.tasks())
  const { data: summary } = useSuspenseQuery(portalQueries.summary())

  return (
    <div className="flex flex-col gap-8">
      {summary === null ? (
        <PortalAllDone principal={principal} />
      ) : (
        <div className="flex flex-col gap-1.5">
          <h1 className="text-2xl font-medium tracking-tight text-balance">
            Hello, {name}
          </h1>
          <p className="text-pretty text-muted-foreground">{summary}</p>
        </div>
      )}

      {tasks.length > 0 ? <PortalTaskList tasks={tasks} /> : null}
    </div>
  )
}
